import { shapeKeywordsForApp } from '../../product/shapeAttributes';
import { updateListingScore } from '../../product/score';

import { OPERATIONS } from '../../../constants/bulkEdit';

export default function keywords({ actions, operation, product, titleFormatPreference }) {
  const channel = product.get('channel');

  switch (operation.get('type')) {
    case OPERATIONS[channel].KEYWORDS.SET: {
      const value = operation.get('value');
      return { actions, product: updateListingScore(product.set('keywords', shapeKeywordsForApp({ channel, value })), { titleFormatPreference }) };
    }

    default: {
      return { actions, product };
    }
  }
}
